// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Input_wrapper__1QF8t","input":"Input_input__HktHc","label":"Input_label__1SNWe","error":"Input_error__3m6jt"};